/* <recently-viewed>: renders the products this visitor opened last.
   product.js stores handles in localStorage; this fetches the section via the search page
   (q = handle:a OR handle:b) so the cards are plain Liquid, then orders them most-recent first. */
(() => {
  if (customElements.get('recently-viewed')) return;
  const KEY = 'expo:recently-viewed';

  const read = () => {
    try {
      const list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.ready || !this.dataset.sectionId || this.querySelector('[data-handle]')) return;
      this.ready = true;
      this.load();
    }

    async load() {
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      const limit = Number(this.dataset.limit) || 8;
      const handles = read().filter((h) => h !== this.dataset.exclude).slice(0, limit);

      if (!handles.length) {
        if (!designMode) this.hidden = true;
        return;
      }

      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('q', handles.map((h) => `handle:${h}`).join(' OR '));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'none');
      url.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const doc = await window.theme.utils.fetchHTML(url.toString());
        const fresh = doc.querySelector('recently-viewed');
        const rail = fresh && fresh.querySelector('.rail');
        if (!rail || !rail.querySelector('[data-handle]')) {
          if (!designMode) this.hidden = true;
          return;
        }
        // Search returns relevance order; restore most-recent-first.
        const items = Array.from(rail.querySelectorAll('[data-handle]'));
        items.sort((a, b) => handles.indexOf(a.dataset.handle) - handles.indexOf(b.dataset.handle));
        items.forEach((item) => rail.append(item));
        this.innerHTML = fresh.innerHTML;
        this.hidden = false;
      } catch (error) {
        if (!designMode) this.hidden = true;
      }
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);
})();
